import { FC, ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import QcsAlert from './basic/QcsAlert';
import { CenterLayoutWrapper } from '../layout/LayoutStyles';

interface Props {
  /** Already-translated error message. Falls back to a generic message when omitted. */
  message?: ReactNode;
}

export const ErrorAlert: FC<Props> = ({ message }) => {
  const { t } = useTranslation();

  return (
    <CenterLayoutWrapper>
      <QcsAlert severity="error">{message ?? t('common.unknownError')}</QcsAlert>
    </CenterLayoutWrapper>
  );
};
